import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {HttpClient,HttpHeaders} from "@angular/common/http";

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {
  private APIURL = environment.baseURL;

  constructor(public httpClient: HttpClient,private authService:AuthService) { this.httpClient = httpClient; }

  getTenderTypeList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/tenderType`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getRoleList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/user/role`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getDisctrictList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/district`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getStateList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/state`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getIndustryList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/industry`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getMOFSubCodeList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/mofSubCode`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getRegistrationTypeList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/registrationType`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getDesignationList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/designation`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getCidbSubCategoryList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/cidbSubCategory`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getCidbGradeList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/cidbGrade`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getListScopeOfWork(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/scopeOfWork`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  getPackageList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/package`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getPackageMasterList(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/package`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getPaymentMethod(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/paymentMethod`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getPaymentMethodTender(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/tenderPaymentMethod`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  

  getAgency(agencyType): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/agency?agencyType=`+agencyType)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getDepartment(agencyCode): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/department?agencyCode=`+agencyCode)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getPtj(jabatanCode): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/ptj?jabatanCode=`+jabatanCode)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getScope(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/scope`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getCategory(scope): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/category?scope=`+scope)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getSubCategory(categoryCode): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/parameter/subCategory?categoryCode=`+categoryCode)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }




  private handleError(error: any): Observable<any> {
    return throwError(error);
  }
}
